function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { useState, useCallback } from 'react';
import { Form, Col, Row } from 'react-bootstrap';
import { Button } from '@rd-web-markets/shared/dist/util/buttons';
import { useTranslation } from 'react-i18next';
import { useErrorHandling } from '@rd-web-markets/shared/dist/hooks/useErrorHandling';
import NoteItem from './NoteItem';
import NoteForm from './NoteForm';
import financialNotesService from '../services/claim/financial_notes.service';
const NotesList = _ref => {
  let {
    notes,
    section,
    claim,
    setClaim
  } = _ref;
  const [loading, setLoading] = useState(false);
  const [newNote, setNewNote] = useState({
    content: '',
    section: section
  });
  const {
    t
  } = useTranslation();
  const handleNoteChange = e => {
    setNewNote(_objectSpread(_objectSpread({}, newNote), {}, {
      'content': e.target.value
    }));
  };
  const addNote = useErrorHandling(useCallback(async () => {
    setLoading(true);
    const createdNote = await financialNotesService.create(claim.id, newNote);
    const updatedNotes = claim.financial_notes;
    updatedNotes.push(createdNote);
    setNewNote({
      content: '',
      section: section
    });
    setClaim(_objectSpread(_objectSpread({}, claim), {}, {
      financial_notes: updatedNotes
    }));
    setLoading(false);
  }, [newNote]));
  const removeNote = useErrorHandling(useCallback(async noteId => {
    await financialNotesService.delete(claim.id, noteId);
    let updatedNotes = claim.financial_notes;
    updatedNotes = updatedNotes.filter(note => note.id !== noteId);
    setClaim(_objectSpread(_objectSpread({}, claim), {}, {
      financial_notes: updatedNotes
    }));
  }, [claim]));
  const editNote = useErrorHandling(useCallback(async (note, index) => {
    const updatedNote = await financialNotesService.edit(claim.id, note);
    let updatedNotes = claim.financial_notes.filter(note => note.section === section);
    updatedNotes[index] = updatedNote;
    setClaim(_objectSpread(_objectSpread({}, claim), {}, {
      financial_notes: updatedNotes
    }));
  }, [claim]));
  return /*#__PURE__*/React.createElement(React.Fragment, null, notes.map((note, index) => {
    return /*#__PURE__*/React.createElement(NoteItem, {
      removeNote: removeNote,
      note: note,
      editNote: editNote,
      index: index
    });
  }), /*#__PURE__*/React.createElement(NoteForm, {
    newNote: newNote,
    handleNoteChange: handleNoteChange,
    addNote: addNote,
    loading: loading
  }));
};
export default NotesList;